// MUTATIONS
export const CLEAN_MAP = "CLEAN_MAP";
export const SET_ACTIVE_DATA = "SET_ACTIVE_DATA";
export const SET_ACTIVE_LAYER_GROUP = "SET_ACTIVE_LAYER_GROUP";
export const SHOW_SUITABILITY_LAYER = "SHOW_SUITABILITY_LAYER";
export const HIDE_SUITABILITY_LAYER = "HIDE_SUITABILITY_LAYER";
export const SET_MARKER = "SET_MARKER";
export const RESET_LAYER_GROUP = "RESET_LAYER_GROUP";
